import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { hideSnackbar } from '../../store/slices/uiSlice';

export default function GlobalSnackbar() {
	const dispatch = useAppDispatch();
	const { snackbar } = useAppSelector((state) => state.ui);

	const handleClose = (_?: React.SyntheticEvent | Event, reason?: string) => {
		if (reason === 'clickaway') {
			return;
		}
		dispatch(hideSnackbar());
	};

	return (
		<Snackbar
			open={snackbar.open}
			autoHideDuration={6000}
			onClose={handleClose}
			anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
		>
			<Alert
				onClose={handleClose}
				severity={snackbar.severity}
				variant="filled"
				sx={{ width: '100%' }}
			>
				{snackbar.message}
			</Alert>
		</Snackbar>
	);
}